// extracted by mini-css-extract-plugin
export default {"body":"HomePage_body__G6eoL","main":"HomePage_main__hj9t6","mainContainer":"HomePage_mainContainer__t1Nn5"};